import React from 'react';
import styles from './ExpandedContent.module.scss';
import TenantsWithCommentBlock from '../../../../../../../HousingStock/components/ui/TenantsWithCommentBlock/TenantsWithCommentBlock';
import DottedBorderBackground from '../../../../../../../HousingStock/components/common/DottedBorderBackground/DottedBorderBackground';
import { addressStagesColorsMap } from '../../../../../../../HousingStock/constants/stagesColorMaps';
import { ReactComponent as HouseWithMagnifierIcon } from '../../../../../../../../resource/HouseWithMagnifier.svg';
import useFlatComments from '../../../../../../../../queries/useFlatComments';

const generateTitle = (flat) => {
  const { porch, address, floor } = flat;
  const { name, typeName, synonym } = address || {};

  const porchBlock = porch ? `${porch} подъезд` : '';
  const typeNameText = typeName?.trim()?.toLowerCase() || '';
  const nameText = name?.trim() || '';
  const additionalInfoText = synonym?.trim() ? `(${synonym.trim()})` : '';
  const floorText = floor ? `${floor} этаж` : '';

  const roomBlock = [nameText, typeNameText, additionalInfoText]
    .filter((text) => text?.trim())
    .join(' ');

  return [porchBlock, roomBlock, floorText]
    .filter((text) => text?.trim())
    .join(', ');
};

const ExpandedContent = ({ flatData }) => {
  const { data: flatComments, isFetching: isFlatCommentsFetching } =
    useFlatComments(flatData?.addressId, {
      staleTime: Infinity,
      enabled: !!flatData?.addressId,
    });

  return (
    <div className={styles.contentRoot}>
      <div className={styles.contentHeader}>
        <DottedBorderBackground className={styles.contentTitleWrap}>
          <HouseWithMagnifierIcon className={styles.contentIcon} />
          <p className={styles.contentTitle}>{generateTitle(flatData)}</p>
        </DottedBorderBackground>
        {Boolean(flatData?.stageName) && (
          <DottedBorderBackground
            style={{
              fontWeight: 700,
              color: '#000',
              backgroundColor:
                addressStagesColorsMap.get(flatData.stageId) || '#fff',
            }}
          >
            {flatData.stageName}
          </DottedBorderBackground>
        )}
      </div>
      <TenantsWithCommentBlock
        tenants={flatData.clients}
        comments={flatComments}
        commentLoading={isFlatCommentsFetching}
        addressId={flatData.addressId}
        hasVisibleDocs={false}
      />
    </div>
  );
};

export default ExpandedContent;
